import { AutoRefreshTokenService, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';
import { environment } from '../environments/environment';

export const provideKeycloakAngular = () => {
  const keycloakUrl = `${!environment.keycloak.isTest ? window.location.origin : 'https://microsec-ids'}/auth`;
  return provideKeycloak({
    config: {
      url: keycloakUrl,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    initOptions: {
      onLoad: 'login-required',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    } as any,
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 1500000,
      }),
    ],
    providers: [AutoRefreshTokenService, UserActivityService],
  });
};
